import {
  WSolidIcon,
  wsolidiconAlarmClock,
  wsolidiconAlertCircle,
  wsolidiconAlertTriangle,
  wsolidiconAnnouncement01,
  wsolidiconArrowCircleBrokenLeft,
  wsolidiconAward03,
  wsolidiconBank,
  wsolidiconBankNote02,
  wsolidiconBankNote03,
  wsolidiconBatteryCharging01,
  wsolidiconBell02,
  wsolidiconBellRinging02,
  wsolidiconBookClosed,
  wsolidiconBox,
  wsolidiconBriefcase01,
  wsolidiconBrush01,
  wsolidiconCalendar,
  wsolidiconCalendarCheck01,
  wsolidiconCalendarHeart01,
  wsolidiconCalendarMinus01,
  wsolidiconCalendarPlus01,
  wsolidiconCheckDone01,
  wsolidiconClapperboard,
  wsolidiconClipboard,
  wsolidiconClipboardAttachment,
  wsolidiconClipboardCheck,
  wsolidiconClipboardDownload,
  wsolidiconClipboardMinus,
  wsolidiconClipboardPlus,
  wsolidiconClipboardX,
  wsolidiconClock,
  wsolidiconClockStopwatch,
  wsolidiconCoins01,
  wsolidiconCoinsStacked01,
  wsolidiconCoinsSwap01,
  wsolidiconCreditCard02,
  wsolidiconCreditCardCheck,
  wsolidiconCreditCardDown,
  wsolidiconCreditCardX,
  wsolidiconDelete,
  wsolidiconDiamond01,
  wsolidiconEraser,
  wsolidiconFaceContent,
  wsolidiconFaceFrown,
  wsolidiconFaceHappy,
  wsolidiconFaceNeutral,
  wsolidiconFaceSmile,
  wsolidiconFastBackward,
  wsolidiconFastForward,
  wsolidiconFile05,
  wsolidiconFile07,
  wsolidiconFileAttachment04,
  wsolidiconFileCheck02,
  wsolidiconFileDownload02,
  wsolidiconFileHeart02,
  wsolidiconFileMinus02,
  wsolidiconFilePlus02,
  wsolidiconFileQuestion02,
  wsolidiconFileSearch02,
  wsolidiconFileX02,
  wsolidiconFileX03,
  wsolidiconFilm02,
  wsolidiconFlag01,
  wsolidiconFolder,
  wsolidiconFolderCheck,
  wsolidiconFolderClosed,
  wsolidiconFolderDownload,
  wsolidiconFolderLock,
  wsolidiconFolderMinus,
  wsolidiconFolderPlus,
  wsolidiconFolderQuestion,
  wsolidiconFolderSearch,
  wsolidiconFolderX,
  wsolidiconGift01,
  wsolidiconGlobe01,
  wsolidiconGlobe02,
  wsolidiconGraduationHat01,
  wsolidiconHeart,
  wsolidiconHourglass02,
  wsolidiconKey01,
  wsolidiconLightbulb03,
  wsolidiconLightning02,
  wsolidiconLock03,
  wsolidiconMail02,
  wsolidiconMarkerPin01,
  wsolidiconMessageAlertCircle,
  wsolidiconMessageChatCircle,
  wsolidiconMessageCheckCircle,
  wsolidiconMessageCircle01,
  wsolidiconMessageDotsCircle,
  wsolidiconMessageSmileCircle,
  wsolidiconMessageXCircle,
  wsolidiconMonitor02,
  wsolidiconMoon01,
  wsolidiconNavigationPointer01,
  wsolidiconNotificationText,
  wsolidiconPaperclip,
  wsolidiconPenTool01,
  wsolidiconPencil02,
  wsolidiconPhoneCall01,
  wsolidiconPiggyBank01,
  wsolidiconPlane,
  wsolidiconPlusCircle,
  wsolidiconPower02,
  wsolidiconReceipt,
  wsolidiconReceiptCheck,
  wsolidiconRocket02,
  wsolidiconSafe,
  wsolidiconScales01,
  wsolidiconSend01,
  wsolidiconShare06,
  wsolidiconShare07,
  wsolidiconShield02,
  wsolidiconShieldOff,
  wsolidiconShoppingBag01,
  wsolidiconStar01,
  wsolidiconStars01,
  wsolidiconStickerCircle,
  wsolidiconSun,
  wsolidiconTag01,
  wsolidiconThumbsDown,
  wsolidiconThumbsUp,
  wsolidiconTicket01,
  wsolidiconTool01,
  wsolidiconTrain,
  wsolidiconTrash04,
  wsolidiconTriangle,
  wsolidiconTrophy01,
  wsolidiconTruck01,
  wsolidiconTypeSquare,
  wsolidiconUpload03,
  wsolidiconUser01,
  wsolidiconUserCheck01,
  wsolidiconUserMinus01,
  wsolidiconUserPlus01,
  wsolidiconUserSquare,
  wsolidiconUserX01,
  wsolidiconUsers01,
  wsolidiconWallet02,
  wsolidiconXCircle,
  wsolidiconCheckCircle,
  wsolidiconCheckCircleBroken,
  wsolidiconInfoCircle,
} from 'wflow-solid-icons';

export const SOLID_ICONS: WSolidIcon[] = [
  wsolidiconAlarmClock,
  wsolidiconAlertCircle,
  wsolidiconAlertTriangle,
  wsolidiconAnnouncement01,
  wsolidiconArrowCircleBrokenLeft,
  wsolidiconAward03,
  wsolidiconBank,
  wsolidiconBankNote03,
  wsolidiconBatteryCharging01,
  wsolidiconBell02,
  wsolidiconBellRinging02,
  wsolidiconBookClosed,
  wsolidiconBox,
  wsolidiconBriefcase01,
  wsolidiconBrush01,
  wsolidiconCalendar,
  wsolidiconCalendarCheck01,
  wsolidiconCalendarHeart01,
  wsolidiconCalendarMinus01,
  wsolidiconCalendarPlus01,
  wsolidiconClapperboard,
  wsolidiconClipboard,
  wsolidiconClipboardAttachment,
  wsolidiconClipboardCheck,
  wsolidiconClipboardDownload,
  wsolidiconClipboardMinus,
  wsolidiconClipboardPlus,
  wsolidiconClipboardX,
  wsolidiconClock,
  wsolidiconClockStopwatch,
  wsolidiconCoins01,
  wsolidiconCoinsStacked01,
  wsolidiconCoinsSwap01,
  wsolidiconCreditCard02,
  wsolidiconCreditCardCheck,
  wsolidiconCreditCardDown,
  wsolidiconCreditCardX,
  wsolidiconDelete,
  wsolidiconDiamond01,
  wsolidiconEraser,
  wsolidiconFaceContent,
  wsolidiconFaceFrown,
  wsolidiconFaceHappy,
  wsolidiconFaceNeutral,
  wsolidiconFaceSmile,
  wsolidiconFastBackward,
  wsolidiconFastForward,
  wsolidiconFile05,
  wsolidiconFile07,
  wsolidiconFileAttachment04,
  wsolidiconFileCheck02,
  wsolidiconFileDownload02,
  wsolidiconFileHeart02,
  wsolidiconFileMinus02,
  wsolidiconFilePlus02,
  wsolidiconFileQuestion02,
  wsolidiconFileSearch02,
  wsolidiconFileX02,
  wsolidiconFilm02,
  wsolidiconFlag01,
  wsolidiconFolderCheck,
  wsolidiconFolderClosed,
  wsolidiconFolderDownload,
  wsolidiconFolderLock,
  wsolidiconFolderMinus,
  wsolidiconFolderPlus,
  wsolidiconFolderQuestion,
  wsolidiconFolderSearch,
  wsolidiconFolderX,
  wsolidiconFolder,
  wsolidiconGift01,
  wsolidiconGlobe01,
  wsolidiconGlobe02,
  wsolidiconGraduationHat01,
  wsolidiconHeart,
  wsolidiconHourglass02,
  wsolidiconKey01,
  wsolidiconLightbulb03,
  wsolidiconLightning02,
  wsolidiconLock03,
  wsolidiconMail02,
  wsolidiconMarkerPin01,
  wsolidiconMessageAlertCircle,
  wsolidiconMessageChatCircle,
  wsolidiconMessageCheckCircle,
  wsolidiconMessageCircle01,
  wsolidiconMessageDotsCircle,
  wsolidiconMessageSmileCircle,
  wsolidiconMessageXCircle,
  wsolidiconMonitor02,
  wsolidiconMoon01,
  wsolidiconNavigationPointer01,
  wsolidiconNotificationText,
  wsolidiconPaperclip,
  wsolidiconPenTool01,
  wsolidiconPencil02,
  wsolidiconPhoneCall01,
  wsolidiconPiggyBank01,
  wsolidiconPlane,
  wsolidiconPlusCircle,
  wsolidiconPower02,
  wsolidiconReceiptCheck,
  wsolidiconReceipt,
  wsolidiconRocket02,
  wsolidiconSafe,
  wsolidiconScales01,
  wsolidiconSend01,
  wsolidiconShare06,
  wsolidiconShare07,
  wsolidiconShield02,
  wsolidiconShieldOff,
  wsolidiconShoppingBag01,
  wsolidiconStar01,
  wsolidiconStars01,
  wsolidiconStickerCircle,
  wsolidiconSun,
  wsolidiconTag01,
  wsolidiconThumbsDown,
  wsolidiconThumbsUp,
  wsolidiconTicket01,
  wsolidiconTool01,
  wsolidiconTrain,
  wsolidiconTrash04,
  wsolidiconTriangle,
  wsolidiconTrophy01,
  wsolidiconTruck01,
  wsolidiconTypeSquare,
  wsolidiconUpload03,
  wsolidiconUser01,
  wsolidiconUserCheck01,
  wsolidiconUserMinus01,
  wsolidiconUserPlus01,
  wsolidiconUserSquare,
  wsolidiconUserX01,
  wsolidiconUsers01,
  wsolidiconWallet02,
  wsolidiconXCircle,
  wsolidiconFileX03,
  wsolidiconBankNote02,
  wsolidiconCheckDone01,
  wsolidiconCheckCircle,
  wsolidiconCheckCircleBroken,
  wsolidiconInfoCircle,
];
